import { useQuery, useMutation } from '@apollo/client';
import {
  GET_COMPANY_CHATS,
  GET_COMPANY_CHAT,
  CREATE_COMPANY_CHAT,
  SEND_COMPANY_CHAT_MESSAGE,
} from './queries';

export function useGetCompanyChatsQuery() {
  return useQuery(GET_COMPANY_CHATS, {
    pollInterval: 6000,
  });
}

export function useGetCompanyChatQuery(chatId: string, p0: { skip: boolean; }) {
  return useQuery(GET_COMPANY_CHAT, {
    variables: { chatId },
    skip: !chatId,
    fetchPolicy: 'no-cache', // Don't use cache at all for this query
  });
}

export function useCreateCompanyChatMutation() {
  return useMutation(CREATE_COMPANY_CHAT, {
    refetchQueries: [{ query: GET_COMPANY_CHATS }],
  });
}

export function useSendCompanyChatMessageMutation() {
  return useMutation(SEND_COMPANY_CHAT_MESSAGE, {
    fetchPolicy: 'no-cache', // Don't let mutation touch the cache
  });
}
